module.exports = __webpack_public_path__ + "img/noOrder@2x.33d2278d.png";